export default {
      id: "logo_header-usage",
      viewBox: "0 0 135 70",
      url: "../dist/images/" + "sprite.svg#logo_header-usage",
      toString: function () {
        return this.url;
      }
    }